<template>
  <!-- 计算异常 -->
  <template v-if="computedInfo">
    <jw-tooltip :content="computedInfo?.tipMsg">
      <qf-icon-warn :size="16" class="computed-icon" />
    </jw-tooltip>
  </template>
  <template v-else-if="getFieldExt && !isNaN(parseFloat(getParams.fieldValue))">
    <template v-if="!['null', 'undefined'].includes(getParams.fieldValue)">
      <!-- 数字（汇总），数字 -->
      <template v-if="[5, 7].includes(getFieldExt?.type)">
        <fh-ellipsis :class="getParams.sourceType === 1 ? 'aligh-right' : ''" :content="tools.getNumberShow(getParams.fieldValue, gfe)" :wrapHeight="rowHeight" />
      </template>
      <!-- 百分比 -->
      <template v-else-if="getFieldExt?.type == 23">
        <fh-ellipsis :class="getParams.sourceType === 1 ? 'aligh-right' : ''" :content="tools.getPercentage(getParams.fieldValue, gfe) + '%'" :wrapHeight="rowHeight" />
      </template>
      <!-- 金额(汇总)，金额 -->
      <template v-else-if="[6, 16].includes(getFieldExt?.type)">
        <fh-ellipsis :class="getParams.sourceType === 1 ? 'aligh-right' : ''" :content="tools.getPriceShow(getParams.fieldValue, gfe)" :wrapHeight="rowHeight" />
      </template>
      <template v-else>
        <!-- 其他 -->
        <fh-ellipsis :content="getParams.fieldValue" :wrapHeight="rowHeight" />
      </template>
    </template>
    <span v-else class="field-content-empty">-</span>
  </template>
  <!-- 文本，日期 -->
  <template v-else>
    <template v-if="clickType === 1">
      <text-field :params="getParams" :clickType="clickType" />
    </template>
    <template v-else>
      <fh-ellipsis v-if="getParams.fieldValue" :content="getParams.fieldValue" :wrapHeight="rowHeight" /> <span v-else class="field-content-empty">{{ getParams?.showEmptyType ? getParams?.showEmptyType : '-' }}</span>
    </template>
  </template>
</template>

<script setup>
import { ref, computed } from 'vue';
import { tools } from '@/utils/tools';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';
import textField from '../../field-edit/text/index.vue';
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  },
  clickType: {
    type: Number,
    default: 0
  }
});
const getParams = computed(() => props.params);
const gfe = ref(getParams.value.fieldExt);
const getFieldExt = computed(() => {
  if (getParams.value.fieldExt && tools.isJSON(gfe.value)) {
    return JSON.parse(gfe.value);
  }
  return null;
});
// 计算错误信息
const computedInfo = computed(() => getParams.value.row?.computedInfo?.computeFieldErrors?.find((fItem) => fItem.fieldKey === getParams.value?.fieldKey));
</script>
<style scoped lang="less">
@import './calculated-field.less';
</style>
